<template>
	<li class="hw_stat__item">
		<div class="hw_stat__date"><span class="ico-calendar" uk-tooltip="Дата"></span> <span>{{ date }}</span></div>
		<div class="hw_stat__wrap">
			<ul class="hw_stat__trains">
				<HwStatItem v-for="(item, key) in train" :key="key" :item="item" />
			</ul>
		</div>
	</li>
</template>

<script>
	import HwStatItem from "./HwStatItem";
  export default {
    name: "hw_stat",
	  components: {
      HwStatItem
	  },
    props: {
      train: '',
      date: ''
    }
  }
</script>